import React, {PureComponent} from "react"

import {FormattedMessage} from "@irati/utils/lang"
import {Para} from "@irati/ui/src/Labels"
import {PlaceholderButton} from "@irati/ui/src/Placeholder"
import {PreviewTextContainer} from "../styled"

interface Props {
  welcomeEmail?: string
}

class EmailContent extends PureComponent<Props> {
  render() {
    const {welcomeEmail} = this.props
    return (
      <PreviewTextContainer border={false}>
        <Para>{welcomeEmail || <FormattedMessage id="admin.components.welcomeEmail.default" />}</Para>
        <PlaceholderButton />
      </PreviewTextContainer>
    )
  }
}

export default EmailContent
